export default __webpack_public_path__ + "assets/images/21487a503ad57de2799d873158211876.svg";